import { useMutation } from '@tanstack/react-query'
import { deleteContactInstrument } from 'services/ContactService'

export const useDeleteContactInstrumentMutation = () => {
  return useMutation({
    mutationFn: deleteContactInstrument,
  })
}
